module.exports = __webpack_public_path__ + "static/headerhero-c700d482c7db0fcad1022abc3dc8b0e6.png";